<div class="dialog-header">
  <div class="header-icon">
    <mat-icon>folder_open</mat-icon>
  </div>
  <div class="header-text">
    <h2 mat-dialog-title class="dialog-title">New project</h2>
    <p class="dialog-subtitle">Set up a trade project on behalf of a company, then add participants.</p>
  </div>
</div>

<mat-dialog-content class="dialog-content">
  <app-error-banner [message]="errorMessage()" />

  <mat-form-field appearance="outline">
    <mat-label>Owner company</mat-label>
    <mat-icon matPrefix>search</mat-icon>
    <input
      matInput
      [(ngModel)]="owner"
      name="owner"
      [matAutocomplete]="ownerAuto"
      placeholder="Search by name or registration no."
    />
    <mat-autocomplete #ownerAuto="matAutocomplete" [displayWith]="displayCompany" panelClass="owner-autocomplete-panel">
      @for (c of filteredCompanies; track c.id) {
        <mat-option [value]="c">
          <div class="company-option">
            <span class="company-option__avatar">{{ c.name.charAt(0) }}</span>
            <div class="company-option__text">
              <span class="company-option__name">{{ c.name }}</span>
              <span class="company-option__meta">{{ c.registrationNo }} · {{ c.countryCode }}</span>
            </div>
          </div>
        </mat-option>
      } @empty {
        <mat-option disabled class="no-match-option">No matching companies found.</mat-option>
      }
    </mat-autocomplete>
    <mat-hint>
      @if (isLoadingCompanies()) {
        Loading approved companies…
      } @else {
        Becomes the project's first participant.
      }
    </mat-hint>
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Name</mat-label>
    <input
      matInput
      [(ngModel)]="form.name"
      name="name"
      maxlength="120"
      placeholder="Q1 2026 Palm Oil Shipment to Rotterdam"
    />
    <mat-hint>Helps participants recognize this project at a glance.</mat-hint>
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Description (optional)</mat-label>
    <textarea
      matInput
      [(ngModel)]="form.description"
      name="description"
      rows="3"
      maxlength="500"
    ></textarea>
    <mat-hint align="end">{{ (form.description ?? '').length }}/500</mat-hint>
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions class="dialog-actions" align="end">
  <button mat-stroked-button class="btn-cancel" (click)="cancel()" [disabled]="isSubmitting()">Cancel</button>
  <button
    mat-flat-button
    class="btn-submit"
    (click)="submit()"
    [disabled]="isSubmitting() || !canSubmit"
  >
    @if (isSubmitting()) {
      <mat-icon class="spinner">progress_activity</mat-icon>
    } @else {
      <mat-icon>add</mat-icon>
    }
    {{ isSubmitting() ? 'Creating...' : 'Create project' }}
  </button>
</mat-dialog-actions>
